<ng-template #content>
  <span class="flat-stat-label">{{ labelKey | translate }}</span>
  <span class="flat-stat-value">{{ value }}</span>
</ng-template>

@if (interactive) {
<button type="button" class="flat-stat is-interactive" (click)="pressed.emit()">
  <ng-container *ngTemplateOutlet="content" />
  <ion-icon name="chevron-forward-outline" class="flat-stat-chevron" aria-hidden="true" />
</button>
} @else {
<div class="flat-stat">
  <ng-container *ngTemplateOutlet="content" />
</div>
}
